export type EmailProvider = 'gmail' | 'outlook' | 'custom';

export interface SmtpPreset {
  smtpServer: string;
  smtpPort: number;
  enableSsl: boolean;
  label: string;
}

export const SMTP_PRESETS: Record<Exclude<EmailProvider, 'custom'>, SmtpPreset> = {
  gmail: {
    label: 'Gmail',
    smtpServer: 'smtp.gmail.com',
    smtpPort: 587,
    enableSsl: true,
  },
  outlook: {
    label: 'Outlook / Microsoft',
    smtpServer: 'smtp.office365.com',
    smtpPort: 587,
    enableSsl: true,
  },
};

const DEFAULT_CUSTOM: SmtpPreset = {
  label: 'Otro proveedor',
  smtpServer: '',
  smtpPort: 587,
  enableSsl: true,
};

function getEmailDomain(email: string): string {
  const trimmed = email.trim().toLowerCase();
  const at = trimmed.lastIndexOf('@');
  if (at < 0) return '';
  return trimmed.slice(at + 1);
}

/** Infiere proveedor a partir del dominio del correo (sin selector manual). */
export function detectProviderFromEmail(email: string): EmailProvider {
  const domain = getEmailDomain(email);
  if (!domain) return 'custom';

  if (domain === 'gmail.com' || domain === 'googlemail.com') return 'gmail';

  if (
    domain.endsWith('.onmicrosoft.com')
    || domain.includes('outlook')
    || domain.includes('hotmail')
    || domain.includes('live.')
    || domain === 'msn.com'
  ) {
    return 'outlook';
  }

  return 'custom';
}

export function detectProviderFromSmtpServer(smtpServer?: string | null): EmailProvider {
  const server = (smtpServer ?? '').trim().toLowerCase();
  if (server.includes('gmail')) return 'gmail';
  if (server.includes('office365') || server.includes('outlook') || server.includes('live.com')) {
    return 'outlook';
  }
  return 'custom';
}

export function resolveSmtpForEmail(
  email: string,
  custom?: Partial<Pick<SmtpPreset, 'smtpServer' | 'smtpPort' | 'enableSsl'>>,
): SmtpPreset {
  const provider = detectProviderFromEmail(email);
  if (provider === 'gmail') return SMTP_PRESETS.gmail;
  if (provider === 'outlook') return SMTP_PRESETS.outlook;

  return {
    ...DEFAULT_CUSTOM,
    smtpServer: custom?.smtpServer?.trim() ?? '',
    smtpPort: custom?.smtpPort ?? 587,
    enableSsl: custom?.enableSsl ?? true,
  };
}
